import { render, staticRenderFns } from "./table-settings.vue?vue&type=template&id=f896ea4c&scoped=true&"
import script from "./table-settings.vue?vue&type=script&lang=js&"
export * from "./table-settings.vue?vue&type=script&lang=js&"
import style0 from "./table-settings.vue?vue&type=style&index=0&id=f896ea4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f896ea4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f896ea4c')) {
      api.createRecord('f896ea4c', component.options)
    } else {
      api.reload('f896ea4c', component.options)
    }
    module.hot.accept("./table-settings.vue?vue&type=template&id=f896ea4c&scoped=true&", function () {
      api.rerender('f896ea4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/table-settings.vue"
export default component.exports